import sharedGenerateEventPair from "src/shared/utilities/generateEventPair";

/* This generates a pair of functions that can be used to
 * dispatch and respond to a CustomEvent with a custom payload
 *
 * @param {Object} options - The options passed to the function
 * @param {string} options.eventName - The name for the CustomEvent
 * @param {array} options.signatureParams - Keys that will be used to compare the event details in the responder to determine if the CustomEvent should be responded to
 * @returns {Object} pairFunctions - An object containing the pair functions
 * @returns {Function} pairFunctions.dispatcher - The function for dispatching the custom event
 * @returns {Function} pairFunctions.responder - The function for responding to the custom event
 */

export default function generateEventPair({
  eventName = "",
  signatureParams = []
}) {
  const { dispatcher, responder: generatedResponder } = sharedGenerateEventPair(
    { eventName, signatureParams }
  );

  const responder = (signature = {}, callback = () => {}, dependencies = []) =>
    generatedResponder(callback, { signature, dependencies });

  return { dispatcher, responder };
}
